import _ from 'lodash'
import Vue from 'vue'
import axios from 'axios'
import * as types from '../types'
import laroute from '../../vendor/laroute'
import swear from '../utils/swear'
import i18n from '../../support/i18n'

const state = {}

const getters = {
    [types.bank_accounts.getters.item]: state => sid => state[sid],
    [types.bank_accounts.getters.items]: state => sid => state[sid],
    [types.bank_accounts.getters.primary]: state => sid => {
        return _.find(state[sid].data, {
            is_default: true
        })
    }
}

const actions = {
    [types.bank_accounts.actions.reset] ({ commit }) {
        commit(types.bank_accounts.mutations.reset)
    },
    [types.bank_accounts.actions.forget] ({ commit }, { sid }) {
        commit(types.bank_accounts.mutations.forgot, sid)
    },
    [types.bank_accounts.actions.get] ({ commit }, { sid, params }) {
        return swear(() => {
            return axios
                .get(laroute.route('api.bank-accounts.index', params))
                .then(({ data: items }) => {
                    commit(types.bank_accounts.mutations.got, { sid, items })
                })
        }, sid)
    },
    [types.bank_accounts.actions.token] ({ commit }, { sid, data = {} }) {
        data = _.cloneDeep(data)
        data.account_number = data.account_number.replace(/-|\s/g, '')
        data.routing_number = data.routing_number.replace(/-|\s/g, '')

        return new Promise((resolve, reject) => {
            Vue.prototype.$stripe
                .createToken(
                    'bank_account',
                    _.pick(data, ['country', 'currency', 'account_number', 'routing_number'])
                )
                .then(({ error, token }) => {
                    if (error) {
                        let errors = {}

                        switch (error.code) {
                            case 'parameter_invalid_empty':
                                errors = {
                                    account_number: [
                                        i18n.t('validation.required', { attribute: 'account number' })
                                    ],
                                    routing_number: [
                                        i18n.t('validation.required', { attribute: 'sort code' })
                                    ]
                                }
                                break
                            case 'account_number_invalid':
                                errors = {
                                    account_number: [
                                        i18n.t('validation.regex', { attribute: 'account number' })
                                    ]
                                }
                                break
                            case 'routing_number_invalid':
                                errors = {
                                    routing_number: [
                                        i18n.t('validation.regex', { attribute: 'sort code' })
                                    ]
                                }
                                break
                            default:
                                errors = {
                                    account_number: [
                                        i18n.t('validation.regex', { attribute: 'account number' })
                                    ],
                                    routing_number: [
                                        i18n.t('validation.regex', { attribute: 'sort code' })
                                    ]
                                }
                        }

                        Vue.prototype.$validator.set({
                            message: 'Whoops!',
                            detail: 'Please check the form for errors.',
                            errors
                        }, sid)

                        reject(error)
                    } else {
                        resolve(token)
                    }
                })
        })
    },
    [types.bank_accounts.actions.store] ({ commit }, { sid, params, data = {} }) {
        return swear(() => {
            return axios
                .post(laroute.route('api.bank-accounts.store', params), data)
                .then(({ data: item }) => {
                    commit(types.bank_accounts.mutations.stored, { sid, item })
                })
        }, sid)
    },
    [types.bank_accounts.actions.update] ({ commit }, { sid, params, data = {} }) {
        return swear(() => {
            return axios
                .patch(laroute.route('api.bank-accounts.update', params), data)
                .then(({ data: item }) => {
                    commit(types.bank_accounts.mutations.updated, { sid, item })
                })
        }, sid)
    },
    [types.bank_accounts.actions.destroy] ({ commit }, { sid, params }) {
        return swear(() => {
            return axios
                .delete(laroute.route('api.bank-accounts.destroy', params))
                .then(({ data: item }) => {
                    commit(types.bank_accounts.mutations.destroyed, { sid, item })
                })
        }, sid)
    }
}

const mutations = {
    [types.bank_accounts.mutations.reset] (state) {
        state = {}
    },
    [types.bank_accounts.mutations.forgot] (state, sid) {
        Vue.delete(state, sid)
    },
    [types.bank_accounts.mutations.got] (state, payload) {
        Vue.set(state, payload.sid, payload.items)
    },
    [types.bank_accounts.mutations.stored] (state, payload) {
        Vue.set(state, payload.sid, payload.item)
    },
    [types.bank_accounts.mutations.updated] (state, payload) {
        Vue.set(state, payload.sid, payload.item)
    },
    [types.bank_accounts.mutations.destroyed] (state, payload) {
        Vue.set(state, payload.sid, payload.item)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
